import { useEffect, useState } from "react";
import api from "../../../../lib/api";

const ACCENT = { GREEN: "text-emerald-700 border-emerald-600", ORANGE: "text-orange-700 border-orange-500", RED: "text-rose-700 border-rose-600" };

export default function Coaching({ p, fallback, legacy }) {
    const [c, setC] = useState(null);
    const load = (refresh) => api.get(`/reporting/ai/pic/${p.id}/coaching`, { params: refresh ? { refresh: 1 } : {}, timeout: 60000 })
        .then(({ data }) => setC(data)).catch(() => setC({ text: fallback, fallback: true }));
    useEffect(() => { if (p.id && p.first_submitted_at) load(false); }, [p.id, p.updated_at]); // eslint-disable-line react-hooks/exhaustive-deps
    const lvl = c?.level;
    if (!c || c.active === false) return legacy;
    return (
        <div className={`mt-4 border-l-2 pl-3 ${ACCENT[lvl] || "border-neutral-300 text-ink"}`} data-testid="sum-coaching" data-level={lvl || ""}>
            <p className="text-[10px] uppercase tracking-widest text-neutral-400">Daily Coaching</p>
            <p className="text-[13px] font-medium leading-snug" data-testid="sum-message">{c?.text || fallback}</p>
            {c?.fallback && p.first_submitted_at && <button type="button" onClick={() => load(true)} className="text-[11px] underline text-neutral-500" data-testid="sum-coaching-retry">Coba AI coaching lagi</button>}
        </div>
    );
}
